const UNITS: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
  { unit: "year", seconds: 365 * 24 * 60 * 60 },
  { unit: "month", seconds: 30 * 24 * 60 * 60 },
  { unit: "week", seconds: 7 * 24 * 60 * 60 },
  { unit: "day", seconds: 24 * 60 * 60 },
  { unit: "hour", seconds: 60 * 60 },
  { unit: "minute", seconds: 60 },
];

export const formatRelativeTime = (
  value: string,
  language: string | undefined,
  now: number = Date.now()
) => {
  const elapsedSeconds = Math.round((new Date(value).getTime() - now) / 1000);
  const formatter = new Intl.RelativeTimeFormat(language || "en", {
    numeric: "auto",
  });

  const match = UNITS.find(
    ({ seconds }) => Math.abs(elapsedSeconds) >= seconds
  );

  return match
    ? formatter.format(Math.round(elapsedSeconds / match.seconds), match.unit)
    : formatter.format(0, "second");
};
